export enum PermissionEnum {
  ADMIN_ARTICLE_CREATE = "ADMIN_ARTICLE_CREATE",
  ADMIN_ARTICLE_UPLOAD_IMAGE = "ADMIN_ARTICLE_UPLOAD_IMAGE",
  ADMIN_ARTICLE_LIST = "ADMIN_ARTICLE_LIST",
  ADMIN_ARTICLE_SHOW = "ADMIN_ARTICLE_SHOW",
  ADMIN_ARTICLE_UPDATE = "ADMIN_ARTICLE_UPDATE",
  ADMIN_ARTICLE_PUBLISH = "ADMIN_ARTICLE_PUBLISH",
  ADMIN_ARTICLE_UNPUBLISH = "ADMIN_ARTICLE_UNPUBLISH",
  ADMIN_ARTICLE_DELETE = "ADMIN_ARTICLE_DELETE",
  ADMIN_ARTICLE_CATEGORY_CREATE = "ADMIN_ARTICLE_CATEGORY_CREATE",
  ADMIN_ARTICLE_CATEGORY_DELETE = "ADMIN_ARTICLE_CATEGORY_DELETE",
  ADMIN_ARTICLE_LANGUAGE_CREATE = "ADMIN_ARTICLE_LANGUAGE_CREATE",
  ADMIN_ARTICLE_LANGUAGE_LIST = "ADMIN_ARTICLE_LANGUAGE_LIST",
  ADMIN_ARTICLE_LANGUAGE_SHOW = "ADMIN_ARTICLE_LANGUAGE_SHOW",
  ADMIN_ARTICLE_LANGUAGE_UPDATE = "ADMIN_ARTICLE_LANGUAGE_UPDATE",
  ADMIN_ARTICLE_LANGUAGE_UPDATE_CONTENT = "ADMIN_ARTICLE_LANGUAGE_UPDATE_CONTENT",
  ADMIN_ARTICLE_LANGUAGE_DELETE = "ADMIN_ARTICLE_LANGUAGE_DELETE",
  ADMIN_BANNER_CREATE = "ADMIN_BANNER_CREATE",
  ADMIN_BANNER_UPLOAD_IMAGE = "ADMIN_BANNER_UPLOAD_IMAGE",
  ADMIN_BANNER_LIST = "ADMIN_BANNER_LIST",
  ADMIN_BANNER_SHOW = "ADMIN_BANNER_SHOW",
  ADMIN_BANNER_UPDATE = "ADMIN_BANNER_UPDATE",
  ADMIN_BANNER_DELETE = "ADMIN_BANNER_DELETE",
  ADMIN_BANNER_MOVE = "ADMIN_BANNER_MOVE",
  ADMIN_CATEGORY_CREATE = "ADMIN_CATEGORY_CREATE",
  ADMIN_CATEGORY_UPLOAD_IMAGE = "ADMIN_CATEGORY_UPLOAD_IMAGE",
  ADMIN_CATEGORY_LIST = "ADMIN_CATEGORY_LIST",
  ADMIN_CATEGORY_SHOW = "ADMIN_CATEGORY_SHOW",
  ADMIN_CATEGORY_UPDATE = "ADMIN_CATEGORY_UPDATE",
  ADMIN_CATEGORY_MOVE = "ADMIN_CATEGORY_MOVE",
  ADMIN_CATEGORY_DELETE = "ADMIN_CATEGORY_DELETE",
  ADMIN_CATEGORY_OPTION_FOR_ARTICLE_FORM = "ADMIN_CATEGORY_OPTION_FOR_ARTICLE_FORM",
  ADMIN_CATEGORY_LANGUAGE_CREATE = "ADMIN_CATEGORY_LANGUAGE_CREATE",
  ADMIN_CATEGORY_LANGUAGE_LIST = "ADMIN_CATEGORY_LANGUAGE_LIST",
  ADMIN_CATEGORY_LANGUAGE_SHOW = "ADMIN_CATEGORY_LANGUAGE_SHOW",
  ADMIN_CATEGORY_LANGUAGE_UPDATE = "ADMIN_CATEGORY_LANGUAGE_UPDATE",
  ADMIN_CATEGORY_LANGUAGE_DELETE = "ADMIN_CATEGORY_LANGUAGE_DELETE",
  ADMIN_DOCTOR_CREATE = "ADMIN_DOCTOR_CREATE",
  ADMIN_DOCTOR_UPLOAD_IMAGE = "ADMIN_DOCTOR_UPLOAD_IMAGE",
  ADMIN_DOCTOR_UPLOAD_THUMBNAIL_IMAGE = "ADMIN_DOCTOR_UPLOAD_THUMBNAIL_IMAGE",
  ADMIN_DOCTOR_LIST = "ADMIN_DOCTOR_LIST",
  ADMIN_DOCTOR_SHOW = "ADMIN_DOCTOR_SHOW",
  ADMIN_DOCTOR_UPDATE = "ADMIN_DOCTOR_UPDATE",
  ADMIN_DOCTOR_DELETE = "ADMIN_DOCTOR_DELETE",
  ADMIN_DOCTOR_OPTION_FOR_MAIN_PAGE_DOCTOR_FORM = "ADMIN_DOCTOR_OPTION_FOR_MAIN_PAGE_DOCTOR_FORM",
  ADMIN_DOCTOR_OPTION_FOR_OUR_DOCTOR_PAGE_DOCTOR_FORM = "ADMIN_DOCTOR_OPTION_FOR_OUR_DOCTOR_PAGE_DOCTOR_FORM",
  ADMIN_DOCTOR_LANGUAGE_CREATE = "ADMIN_DOCTOR_LANGUAGE_CREATE",
  ADMIN_DOCTOR_LANGUAGE_UPDATE = "ADMIN_DOCTOR_LANGUAGE_UPDATE",
  ADMIN_DOCTOR_LANGUAGE_UPDATE_CONTENT = "ADMIN_DOCTOR_LANGUAGE_UPDATE_CONTENT",
  ADMIN_DOCTOR_LANGUAGE_DELETE = "ADMIN_DOCTOR_LANGUAGE_DELETE",
  ADMIN_LANGUAGE_OPTION_FOR_ARTICLE_LANGUAGE_FORM = "ADMIN_LANGUAGE_OPTION_FOR_ARTICLE_LANGUAGE_FORM",
  ADMIN_LANGUAGE_OPTION_FOR_CATEGORY_LANGUAGE_FORM = "ADMIN_LANGUAGE_OPTION_FOR_CATEGORY_LANGUAGE_FORM",
  ADMIN_LANGUAGE_OPTION_FOR_DOCTOR_LANGUAGE_FORM = "ADMIN_LANGUAGE_OPTION_FOR_DOCTOR_LANGUAGE_FORM",
  ADMIN_LANGUAGE_OPTION_FOR_PROMOTION_LANGUAGE_FORM = "ADMIN_LANGUAGE_OPTION_FOR_PROMOTION_LANGUAGE_FORM",
  ADMIN_LANGUAGE_OPTION_FOR_LOCATION_GROUP_LANGUAGE_FORM = "ADMIN_LANGUAGE_OPTION_FOR_LOCATION_GROUP_LANGUAGE_FORM",
  ADMIN_LANGUAGE_OPTION_FOR_LOCATION_LABEL_LANGUAGE_FORM = "ADMIN_LANGUAGE_OPTION_FOR_LOCATION_LABEL_LANGUAGE_FORM",
  ADMIN_LANGUAGE_OPTION_FOR_LOCATION_LANGUAGE_FORM = "ADMIN_LANGUAGE_OPTION_FOR_LOCATION_LANGUAGE_FORM",
  ADMIN_LANGUAGE_OPTION_FOR_LOCATION_IMAGE_LANGUAGE_FORM = "ADMIN_LANGUAGE_OPTION_FOR_LOCATION_IMAGE_LANGUAGE_FORM",
  ADMIN_LANGUAGE_OPTION_FOR_LOCATION_SERVICE_LANGUAGE_FORM = "ADMIN_LANGUAGE_OPTION_FOR_LOCATION_SERVICE_LANGUAGE_FORM",
  ADMIN_LOCATION_GROUP_CREATE = "ADMIN_LOCATION_GROUP_CREATE",
  ADMIN_LOCATION_GROUP_UPLOAD_IMAGE = "ADMIN_LOCATION_GROUP_UPLOAD_IMAGE",
  ADMIN_LOCATION_GROUP_LIST = "ADMIN_LOCATION_GROUP_LIST",
  ADMIN_LOCATION_GROUP_SHOW = "ADMIN_LOCATION_GROUP_SHOW",
  ADMIN_LOCATION_GROUP_UPDATE_IMAGE = "ADMIN_LOCATION_GROUP_UPDATE_IMAGE",
  ADMIN_LOCATION_GROUP_DELETE = "ADMIN_LOCATION_GROUP_DELETE",
  ADMIN_LOCATION_GROUP_OPTION_FOR_LOCATION_FORM = "ADMIN_LOCATION_GROUP_OPTION_FOR_LOCATION_FORM",
  ADMIN_LOCATION_GROUP_OPTION_FOR_LOCATION_FILTER = "ADMIN_LOCATION_GROUP_OPTION_FOR_LOCATION_FILTER",
  ADMIN_LOCATION_GROUP_LANGUAGE_CREATE = "ADMIN_LOCATION_GROUP_LANGUAGE_CREATE",
  ADMIN_LOCATION_GROUP_LANGUAGE_LIST = "ADMIN_LOCATION_GROUP_LANGUAGE_LIST",
  ADMIN_LOCATION_GROUP_LANGUAGE_SHOW = "ADMIN_LOCATION_GROUP_LANGUAGE_SHOW",
  ADMIN_LOCATION_GROUP_LANGUAGE_UPDATE = "ADMIN_LOCATION_GROUP_LANGUAGE_UPDATE",
  ADMIN_LOCATION_GROUP_LANGUAGE_DELETE = "ADMIN_LOCATION_GROUP_LANGUAGE_DELETE",
  ADMIN_LOCATION_LANGUAGE_CREATE = "ADMIN_LOCATION_LANGUAGE_CREATE",
  ADMIN_LOCATION_LANGUAGE_LIST = "ADMIN_LOCATION_LANGUAGE_LIST",
  ADMIN_LOCATION_LANGUAGE_SHOW = "ADMIN_LOCATION_LANGUAGE_SHOW",
  ADMIN_LOCATION_LANGUAGE_UPDATE = "ADMIN_LOCATION_LANGUAGE_UPDATE",
  ADMIN_LOCATION_LANGUAGE_DELETE = "ADMIN_LOCATION_LANGUAGE_DELETE",
  ADMIN_LOCATION_CREATE = "ADMIN_LOCATION_CREATE",
  ADMIN_LOCATION_LIST = "ADMIN_LOCATION_LIST",
  ADMIN_LOCATION_SHOW = "ADMIN_LOCATION_SHOW",
  ADMIN_LOCATION_UPDATE = "ADMIN_LOCATION_UPDATE",
  ADMIN_LOCATION_DELETE = "ADMIN_LOCATION_DELETE",
  ADMIN_LOCATION_IMAGE_CREATE = "ADMIN_LOCATION_IMAGE_CREATE",
  ADMIN_LOCATION_IMAGE_LIST = "ADMIN_LOCATION_IMAGE_LIST",
  ADMIN_LOCATION_IMAGE_SHOW = "ADMIN_LOCATION_IMAGE_SHOW",
  ADMIN_LOCATION_IMAGE_UPLOAD = "ADMIN_LOCATION_IMAGE_UPLOAD",
  ADMIN_LOCATION_IMAGE_UPDATE_IMAGE = "ADMIN_LOCATION_IMAGE_UPDATE_IMAGE",
  ADMIN_LOCATION_IMAGE_MOVE = "ADMIN_LOCATION_IMAGE_MOVE",
  ADMIN_LOCATION_IMAGE_DELETE = "ADMIN_LOCATION_IMAGE_DELETE",
  ADMIN_LOCATION_HAS_SERVICE_CREATE = "ADMIN_LOCATION_HAS_SERVICE_CREATE",
  ADMIN_LOCATION_HAS_SERVICE_LIST = "ADMIN_LOCATION_HAS_SERVICE_LIST",
  ADMIN_LOCATION_HAS_SERVICE_MOVE = "ADMIN_LOCATION_HAS_SERVICE_MOVE",
  ADMIN_LOCATION_HAS_SERVICE_DELETE = "ADMIN_LOCATION_HAS_SERVICE_DELETE",
  ADMIN_LOCATION_REVIEW_CREATE = "ADMIN_LOCATION_REVIEW_CREATE",
  ADMIN_LOCATION_REVIEW_UPLOAD_IMAGE = "ADMIN_LOCATION_REVIEW_UPLOAD_IMAGE",
  ADMIN_LOCATION_REVIEW_LIST = "ADMIN_LOCATION_REVIEW_LIST",
  ADMIN_LOCATION_REVIEW_SHOW = "ADMIN_LOCATION_REVIEW_SHOW",
  ADMIN_LOCATION_REVIEW_UPDATE = "ADMIN_LOCATION_REVIEW_UPDATE",
  ADMIN_LOCATION_REVIEW_DELETE = "ADMIN_LOCATION_REVIEW_DELETE",
  ADMIN_LOCATION_IMAGE_LANGUAGE_CREATE = "ADMIN_LOCATION_IMAGE_LANGUAGE_CREATE",
  ADMIN_LOCATION_IMAGE_LANGUAGE_LIST = "ADMIN_LOCATION_IMAGE_LANGUAGE_LIST",
  ADMIN_LOCATION_IMAGE_LANGUAGE_SHOW = "ADMIN_LOCATION_IMAGE_LANGUAGE_SHOW",
  ADMIN_LOCATION_IMAGE_LANGUAGE_UPDATE = "ADMIN_LOCATION_IMAGE_LANGUAGE_UPDATE",
  ADMIN_LOCATION_IMAGE_LANGUAGE_DELETE = "ADMIN_LOCATION_IMAGE_LANGUAGE_DELETE",
  ADMIN_LOCATION_LABEL_CREATE = "ADMIN_LOCATION_LABEL_CREATE",
  ADMIN_LOCATION_LABEL_UPLOAD_MAP_ICON = "ADMIN_LOCATION_LABEL_UPLOAD_MAP_ICON",
  ADMIN_LOCATION_LABEL_LIST = "ADMIN_LOCATION_LABEL_LIST",
  ADMIN_LOCATION_LABEL_SHOW = "ADMIN_LOCATION_LABEL_SHOW",
  ADMIN_LOCATION_LABEL_UPDATE_MAP_ICON = "ADMIN_LOCATION_LABEL_UPDATE_MAP_ICON",
  ADMIN_LOCATION_LABEL_DELETE = "ADMIN_LOCATION_LABEL_DELETE",
  ADMIN_LOCATION_LABEL_OPTION_FOR_LOCATION_FORM = "ADMIN_LOCATION_LABEL_OPTION_FOR_LOCATION_FORM",
  ADMIN_LOCATION_LABEL_LANGUAGE_CREATE = "ADMIN_LOCATION_LABEL_LANGUAGE_CREATE",
  ADMIN_LOCATION_LABEL_LANGUAGE_UPDATE = "ADMIN_LOCATION_LABEL_LANGUAGE_UPDATE",
  ADMIN_LOCATION_LABEL_LANGUAGE_DELETE = "ADMIN_LOCATION_LABEL_LANGUAGE_DELETE",
  ADMIN_LOCATION_SERVICE_CREATE = "ADMIN_LOCATION_SERVICE_CREATE",
  ADMIN_LOCATION_SERVICE_UPLOAD_IMAGE = "ADMIN_LOCATION_SERVICE_UPLOAD_IMAGE",
  ADMIN_LOCATION_SERVICE_LIST = "ADMIN_LOCATION_SERVICE_LIST",
  ADMIN_LOCATION_SERVICE_SHOW = "ADMIN_LOCATION_SERVICE_SHOW",
  ADMIN_LOCATION_SERVICE_UPDATE_IMAGE = "ADMIN_LOCATION_SERVICE_UPDATE_IMAGE",
  ADMIN_LOCATION_SERVICE_DELETE = "ADMIN_LOCATION_SERVICE_DELETE",
  ADMIN_LOCATION_SERVICE_OPTION_FOR_LOCATION_FORM = "ADMIN_LOCATION_SERVICE_OPTION_FOR_LOCATION_FORM",
  ADMIN_LOCATION_SERVICE_LANGUAGE_CREATE = "ADMIN_LOCATION_SERVICE_LANGUAGE_CREATE",
  ADMIN_LOCATION_SERVICE_LANGUAGE_SHOW = "ADMIN_LOCATION_SERVICE_LANGUAGE_SHOW",
  ADMIN_LOCATION_SERVICE_LANGUAGE_UPDATE = "ADMIN_LOCATION_SERVICE_LANGUAGE_UPDATE",
  ADMIN_LOCATION_SERVICE_LANGUAGE_DELETE = "ADMIN_LOCATION_SERVICE_LANGUAGE_DELETE",
  ADMIN_MAIN_PAGE_DOCTOR_CREATE = "ADMIN_MAIN_PAGE_DOCTOR_CREATE",
  ADMIN_MAIN_PAGE_DOCTOR_FETCH = "ADMIN_MAIN_PAGE_DOCTOR_FETCH",
  ADMIN_MAIN_PAGE_DOCTOR_MOVE = "ADMIN_MAIN_PAGE_DOCTOR_MOVE",
  ADMIN_MAIN_PAGE_DOCTOR_DELETE = "ADMIN_MAIN_PAGE_DOCTOR_DELETE",
  ADMIN_MAIN_PAGE_LOCATION_GROUP_CREATE = "ADMIN_MAIN_PAGE_LOCATION_GROUP_CREATE",
  ADMIN_MAIN_PAGE_LOCATION_GROUP_FETCH = "ADMIN_MAIN_PAGE_LOCATION_GROUP_FETCH",
  ADMIN_MAIN_PAGE_LOCATION_GROUP_MOVE = "ADMIN_MAIN_PAGE_LOCATION_GROUP_MOVE",
  ADMIN_MAIN_PAGE_LOCATION_GROUP_DELETE = "ADMIN_MAIN_PAGE_LOCATION_GROUP_DELETE",
  ADMIN_MAIN_PAGE_VIDEO_CREATE = "ADMIN_MAIN_PAGE_VIDEO_CREATE",
  ADMIN_MAIN_PAGE_VIDEO_UPLOAD_IMAGE = "ADMIN_MAIN_PAGE_VIDEO_UPLOAD_IMAGE",
  ADMIN_MAIN_PAGE_VIDEO_LIST = "ADMIN_MAIN_PAGE_VIDEO_LIST",
  ADMIN_MAIN_PAGE_VIDEO_SHOW = "ADMIN_MAIN_PAGE_VIDEO_SHOW",
  ADMIN_MAIN_PAGE_VIDEO_UPDATE = "ADMIN_MAIN_PAGE_VIDEO_UPDATE",
  ADMIN_MAIN_PAGE_VIDEO_MOVE = "ADMIN_MAIN_PAGE_VIDEO_MOVE",
  ADMIN_MAIN_PAGE_VIDEO_DELETE = "ADMIN_MAIN_PAGE_VIDEO_DELETE",
  ADMIN_PROMOTION_CREATE = "ADMIN_PROMOTION_CREATE",
  ADMIN_PROMOTION_UPLOAD_IMAGE = "ADMIN_PROMOTION_UPLOAD_IMAGE",
  ADMIN_PROMOTION_LIST = "ADMIN_PROMOTION_LIST",
  ADMIN_PROMOTION_SHOW = "ADMIN_PROMOTION_SHOW",
  ADMIN_PROMOTION_MOVE = "ADMIN_PROMOTION_MOVE",
  ADMIN_PROMOTION_UPDATE = "ADMIN_PROMOTION_UPDATE",
  ADMIN_PROMOTION_PUBLISH = "ADMIN_PROMOTION_PUBLISH",
  ADMIN_PROMOTION_UNPUBLISH = "ADMIN_PROMOTION_UNPUBLISH",
  ADMIN_PROMOTION_DELETE = "ADMIN_PROMOTION_DELETE",
  ADMIN_PROMOTION_LANGUAGE_CREATE = "ADMIN_PROMOTION_LANGUAGE_CREATE",
  ADMIN_PROMOTION_LANGUAGE_LIST = "ADMIN_PROMOTION_LANGUAGE_LIST",
  ADMIN_PROMOTION_LANGUAGE_SHOW = "ADMIN_PROMOTION_LANGUAGE_SHOW",
  ADMIN_PROMOTION_LANGUAGE_UPDATE = "ADMIN_PROMOTION_LANGUAGE_UPDATE",
  ADMIN_PROMOTION_LANGUAGE_UPDATE_CONTENT = "ADMIN_PROMOTION_LANGUAGE_UPDATE_CONTENT",
  ADMIN_PROMOTION_LANGUAGE_UPDATE_TERM_AND_CONDITIONS = "ADMIN_PROMOTION_LANGUAGE_UPDATE_TERM_AND_CONDITIONS",
  ADMIN_PROMOTION_LANGUAGE_DELETE = "ADMIN_PROMOTION_LANGUAGE_DELETE",
  ADMIN_OUR_DOCTOR_PAGE_DOCTOR_CREATE = "ADMIN_OUR_DOCTOR_PAGE_DOCTOR_CREATE",
  ADMIN_OUR_DOCTOR_PAGE_DOCTOR_FETCH = "ADMIN_OUR_DOCTOR_PAGE_DOCTOR_FETCH",
  ADMIN_OUR_DOCTOR_PAGE_DOCTOR_MOVE = "ADMIN_OUR_DOCTOR_PAGE_DOCTOR_MOVE",
  ADMIN_OUR_DOCTOR_PAGE_DOCTOR_DELETE = "ADMIN_OUR_DOCTOR_PAGE_DOCTOR_DELETE",
  ADMIN_ROLE_LIST = "ADMIN_ROLE_LIST",
  ADMIN_ROLE_SHOW = "ADMIN_ROLE_SHOW",
  ADMIN_ROLE_OPTION = "ADMIN_ROLE_OPTION",
  ADMIN_ROLE_OPTION_FOR_USER_FILTER = "ADMIN_ROLE_OPTION_FOR_USER_FILTER",
  ADMIN_ROLE_OPTION_FOR_USER_FORM = "ADMIN_ROLE_OPTION_FOR_USER_FORM",
  ADMIN_USER_CREATE = "ADMIN_USER_CREATE",
  ADMIN_USER_LIST = "ADMIN_USER_LIST",
  ADMIN_USER_SHOW = "ADMIN_USER_SHOW",
  ADMIN_USER_UPDATE = "ADMIN_USER_UPDATE",
  ADMIN_USER_OPTION_FOR_ARTICLE_FORM = "ADMIN_USER_OPTION_FOR_ARTICLE_FORM"
}
